export const caisseConstants = {
  GET_RELEVE: "GET_RELEVE",
  GET_ALL_RELEVE: "GET_ALL_RELEVE",
  GET_JOURNAL: "GET_JOURNAL",
  SET_LOADING: "SET_LOADING",
  SET_BOURSIERS: "SET_BOURSIERS",
};
